import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { tradingSeatsContext } from '../../config/seatTrade'

import { v1setContextMenu } from '../../actions/contextMenu'
import { v1resetNotifications } from '../../actions/notifications'
import { v1requestFilteredTourOperators } from '../../actions/tourOperators'

import SeatTradeSearchResults from '../../components/SeatTradeSearchResults'

export const mapStateToProps = state => {
  const {
    v1seatTrade: {
      isFetching,
      items: searchResults,
      seatsAreBeingTraded,
      errors,
      notifications: seatTradeNotifications,
    },
    v1airports: { items: airports },
    v1searchQuery: {
      results: { departureAirportId, arrivalAirportId },
    },
    v1contextMenu: { context },
    v1errors: { errors: genericErrors },
    v1notifications: { notifications },
  } = state

  return {
    departureAirport: airports.find(
      airport => airport.id === departureAirportId
    ) || { name: departureAirportId },
    arrivalAirport: airports.find(
      airport => airport.id === arrivalAirportId
    ) || {
      name: arrivalAirportId,
    },
    searchResults,
    isFetching,
    confirmTrade: context === tradingSeatsContext || seatsAreBeingTraded,
    context,
    seatsAreBeingTraded,
    notifications,
    seatTradeNotifications,
    errors: [...genericErrors, ...errors],
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      requestFilteredTourOperators: v1requestFilteredTourOperators,
      setContextMenu: v1setContextMenu,
      resetNotifications: v1resetNotifications,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeatTradeSearchResults)
